<template>
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23.5 20.43945">
		<path fill-rule="evenodd" d="M11.75 14.18945a4 4 0 1 0-4-4 4 4 0 0 0 4 4Z"/>
		<path d="M11.75 17.93945c-6.479 0-11.75-3.47656-11.75-7.75s5.271-7.75 11.75-7.75c6.47852 0 11.75 3.47656 11.75 7.75s-5.27148 7.75-11.75 7.75Zm0-14c-5.65186 0-10.25 2.80371-10.25 6.25s4.59814 6.25 10.25 6.25c5.65234 0 10.25-2.80371 10.25-6.25s-4.59766-6.25-10.25-6.25Z"/>
	</svg>
</template>
